import { Injectable } from '@angular/core';
import {
  Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot,
  UrlTree, CanLoad, Route, UrlSegment
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {

  constructor(
    private router: Router,
    private authService: AuthService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.isLogin().then((isAuthenticated) => {
      if (!isAuthenticated) {
        const redirectUrl = (state.url) ? state.url : environment.auth.redirectUrl;
        this.router.navigate([environment.auth.loginUrl], { queryParams: { returnUrl: redirectUrl } });
        // this.router.navigate([environment.depatmentlogin.redirectadminUrl], { queryParams: { redirectadminUrl: redirectUrl } });

      }
      return isAuthenticated;
    });
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }

}
